module.exports = __webpack_public_path__ + "static/img/imagination_01.20ede7c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/recruit_2022/corona/imagination_01.png
// module id = cRhW
// module chunks = 0